import { Button, Modal } from 'antd'
import React, { useState } from 'react'
import metaData from 'metadata/questionlogs'
import { IQuestionLogs } from 'interfaces'
import { useTable } from '@pankod/refine-core'
import { Icons, Timeline, DateField } from '@pankod/refine-antd'

type QuestionLogsProps = {
  questionId: any
}

const dummy = [
  {
    description: 'Shyam has created this question in work request id : 2131 (dummy)',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Sunil has been assinged to review this question in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Sunil have reviewed and passed the question to Mini for approval in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Sunil rejected this question at review stage in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Sunil (Reviewer) returned this question to Shyam (Creator) for amending in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Mini have approved and set this question to published status in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Mini rejected this question at approval stage in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Mini (Approver) returned this question to Sunil (Reviewer) for amending in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Shyam has edited this question in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
]

const QuestionLogs: React.FC<QuestionLogsProps> = ({ questionId }) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const { filters, setFilters, tableQueryResult, sorter, current, setCurrent, pageCount, setPageSize } = useTable<IQuestionLogs>({
    resource: 'question_logs',
    initialSorter: [
      {
        field: 'created_at',
        order: 'asc',
      },
    ],
    permanentFilter: [
      {
        field: 'question_id',
        operator: 'eq',
        value: questionId,
      },
    ],
    queryOptions: {
      enabled: !!questionId,
    },

    metaData,
  })

 

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleOk = () => {
    setIsModalVisible(false)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  return (
    <>
      <Button key="logs" onClick={showModal} icon={<Icons.DatabaseOutlined />}>
        Logs
      </Button>
      <Modal title="Question Logs" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} style={{ minWidth: '1000px' }}>
        {tableQueryResult?.data?.data?.map(log => {
          return (
            <Timeline.Item>
              <div>{log.description}</div>
              <DateField format="LLL" value={log.created_at} />
            </Timeline.Item>
          )
        })}
        {/* <Timeline>
          {dummy.map(log => {
            return (
              <Timeline.Item>
                <div>{log.description}</div>
                <DateField format="LLL" value={log.created_at} />
              </Timeline.Item>
            )
          })}
        </Timeline> */}
      </Modal>
    </>
  )
}

export default QuestionLogs
